// extracted by mini-css-extract-plugin
export default {"grid":"PlayerAboutStep_grid__i6fF2"};